/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : Customer detail page of rayi
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

// custom components
import { StatisticCard } from '../../Components/Card';
import { Chip, CustomTab, CustomTooltip, OverLay } from '../../Components/Others';
import { AccountCreation, ExternalFunds, FamilyDetails, Holdings, NonFinancialChanges, Order, Portfolio, Profile, RebalanceLog, Referral, SystematicPlans } from './Helper';
import { Icon } from '../../Components/Icon';
import { CheckStatusModal, ConfirmModal } from '../../Components/Modal';
import { APIService } from '../../Service';

// custom style 
import style from "../../Style/Component/customer.module.scss";
import { PrimaryButton, SecondaryButton } from '../../Components/Buttons';

const TAB_TITLES = [
    { id: 1, label: 'Profile' },
    { id: 2, label: 'Orders' },
    { id: 3, label: 'Portfolio' },
    { id: 4, label: 'Systematics Plan' },
    { id: 5, label: 'Family details' },
    { id: 6, label: 'Audit trails & rebalance log' },
    // { id: 7, label: 'Non-Financial Changes' },
    { id: 8, label: 'Account Creation' },
    { id: 10, label: 'Referral' },
];

const CustomerDetail = () => {
    const { state } = useLocation();
    const { id } = useParams();
    const location = useLocation();

    const navigate = useNavigate();

    const source = state?.source || "normal_listing";

    const [selectedTab, setSelectedTab] = useState(-1);
    const [toggleMenu, setToggleMenu] = useState(false);

    const [blockConfirm, setBlockConfirm] = useState(false);
    const [blockStatus, setBlockStatus] = useState(false);

    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [loader, setLoader] = useState(true);
    const [isCustomerBlocked, setIsCustomerBlocked] = useState(false);

    const [userDetailData, setUserDetailData] = useState({});
    const [shortName, setShortName] = useState("");
    const [userDeleteLoader, setUserDeleteLoader] = useState(false);

    const [checkStatusLoader, setCheckStatusLoader] = useState(false);
    const [kycStatusData, setKycStatusData] = useState([]);
    const [checkStatus, setCheckStatus] = useState(false);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
        setLoader(true);
        setToggleMenu(false);
        _userDetail();
    }, [id]);

    useEffect(() => {
        if (state !== null) {
            if (state.inner_tab_index === 9) {
                const legacyOrderTabMap = { 1: 7, 2: 8, 3: 9 };
                const orderTab = legacyOrderTabMap[state.other_transactions_tab || 1] || 7;
                navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
                    state: {
                        ...state,
                        inner_tab_index: 2,
                        order_tab: orderTab,
                    },
                    replace: true,
                });
                return;
            }
            if (state.inner_tab_index) {
                setSelectedTab(state.inner_tab_index);
            } else {
                setSelectedTab(1);
            }
        } else {
            // navigate("/customers");
            // alert("/customers")
            setSelectedTab(1);
        }
    }, [state]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    useEffect(() => {
        if (blockConfirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [blockConfirm]);

    useEffect(() => {
        if (checkStatus === true) {
            const modal = new Modal(document.getElementById("check-status-modal"));
            modal.show();
        }
    }, [checkStatus]);


    // handle tab change
    const _handleTab = (tab_id) => {
        navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
            state: {
                ...state,
                inner_tab_index: tab_id,
                portfolio_tab_index: 1
            }
        });
    };

    // handle toggle menu
    const _handleToggleMenu = () => {
        setToggleMenu(prev => !prev);
    };

    // handle data delete
    const _handleDataDelete = () => {
        setConfirm(true);
        setToggleMenu(false);
    };

    // handle block customer
    const _handleBlockCustomer = () => {
        setBlockConfirm(true);
        setToggleMenu(false);
    };

    const _handleReferredByClick = () => {
        const referred_by_id = userDetailData?.customer_summary?.referred_by?.customer_id;
        if (!referred_by_id) {
            return;
        }
        navigate(location.pathname.includes("support") ? `/support/${referred_by_id}` : `/customers/${referred_by_id}`, {
            state: {
                source: location.pathname.includes("support") ? "customer_support" : "normal_listing",
                inner_tab_index: 10
            }
        });
    };

    // handle previous page
    const _handleBack = () => {
        if (state !== null) {
            // navigate(location.pathname.includes("support") ? "/support" : "/customers", {
            //     state: {
            //         type: state.selected_type,
            //         tab_index: state.tab_index,
            //         current_page: state.current_page
            //     }
            // })
            if (state?.source === "normal_listing") {
                navigate("/customers", {
                    state: {
                        ...state,
                        type: state.selected_type,
                        current_page: state.current_page,
                        search: state.search,
                    }
                });
            } else if (state?.source === "customer_support") {
                navigate("/support", {
                    state: {
                        type: state.selected_type,
                        tab_index: state.tab_index,
                        current_page: state.current_page
                    }
                });
            }
            else {
                navigate("/customers");
            }

        } else {
            if (location.pathname.includes("support")) {
                navigate("/support");
            } else {
                navigate("/customers");
            }
        }
    };

    // handle check status
    const _handleCheckStatus = () => {
        _checkStatus();
    };


    // API -user detail
    const _userDetail = () => {
        let is_post = true;
        let url = location.pathname.includes("support") ? 'support-customers/detail' : 'user/detail';
        let request = {
            "customer_id": Number(id)
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                let updated_name = response.data.customer_summary.customer_name.split(" ");
                let short_name;

                if (updated_name.length > 1) {
                    short_name = updated_name[0].substring(0, 1) + updated_name[1].substring(0, 1)
                } else {
                    short_name = updated_name[0].substring(0, 2)
                }

                setShortName(short_name.toUpperCase());

                setUserDetailData(response.data);

                setIsCustomerBlocked(response.data.profile.is_blocked);
                setLoader(false);

            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });

                if (location.pathname.includes("support")) {
                    navigate("/support");
                } else {
                    setTimeout(() => {
                        navigate(-1);
                    }, 1000);
                }
                // setUserDetailData([]);
            }
        });
    };

    // API - block customer
    const _blockCustomer = () => {
        let is_post = true;
        let url = 'user/block';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setIsCustomerBlocked(response.data.is_blocked);
                setBlockStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    // API - User delete
    const _userDelete = (data) => {
        let is_post = true;
        let url = 'user/delete';
        let request = {
            "customer_id": id,
            "ticket_number": data?.fresh_desk_number ?? null
        }
        setUserDeleteLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
            setUserDeleteLoader(false);
        })
    };


    // API - Check customer status
    const _checkStatus = () => {

        let is_post = true;
        let url = 'non-kyc-user/check-kyc-status';
        let request = {
            customer_ids: [id]
        }

        setCheckStatusLoader(true);

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setCheckStatus(true);
                setKycStatusData(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: 'error' })
            }
            setCheckStatusLoader(false);
        })
    };



    return (
        <Fragment>


            <section className='e-section-height pb-5' >
                {loader ?
                    <div className='d-flex align-items-center justify-content-center pt-4 e-section-loader-height'>
                        <img src={require("../../Assets/Image/loader.gif")}
                            draggable={false}
                            alt='loader'
                            width={80}
                            height={80}
                            className='text-center' />
                    </div>
                    :
                    <>
                        <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom  d-flex align-items-center gap-2 justify-content-between'>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                                <span className='text-decoration-hover-underline cursor-pointer'
                                    onClick={() => _handleBack()}>
                                    <Icon icon="back"
                                        size={20}
                                        className="margin-10px-right"
                                        color="#292D32" />
                                    {location.pathname.includes("support") ? 'Support-Customers' : 'Customers'} </span> /
                                {userDetailData?.customer_summary?.referred_by?.name && (
                                    <>
                                        <span
                                            className={`px-1 e-font-weight-600${userDetailData.customer_summary?.referred_by?.customer_id ? ' text-decoration-hover-underline cursor-pointer' : ''}`}
                                            onClick={userDetailData.customer_summary?.referred_by?.customer_id ? _handleReferredByClick : undefined}
                                        >
                                            {userDetailData.customer_summary?.referred_by?.name}
                                        </span>
                                        {'/'}
                                    </>
                                )}
                                <span className='e-font-weight-600 ps-1'>
                                    {userDetailData.customer_summary.customer_name}
                                </span>

                            </p>

                            {(userDetailData.profile?.kyc_step === "kyc submitted" || userDetailData.kyc_details.fresh_kyc_submitted === true) &&
                                < SecondaryButton
                                    name="Check the status"
                                    paddingBlock='padding-12px-tb padding-24px-lr'
                                    loader={checkStatusLoader}
                                    className={checkStatusLoader ? 'w-148px h-42px' : ''}
                                    onClick={_handleCheckStatus}
                                />
                            }
                        </div>


                        <div className='padding-52px-lr margin--80px-top'>
                            {/* Customer summary */}
                            <div className={`${style.e_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-tb px-4 position-relative`}>
                                <div className='d-flex gap-4 align-items-start '>
                                    <div className='e-bg-blue-violet-light border-radius-64 padding-22px-lr py-4 rounded-circle w-76px h-76px d-flex flex-column justify-content-center align-items-center'>
                                        <p className='mb-0 e-text-cultured-light e-primary-font e-font-20 e-font-weight-400 line-height-20px'>
                                            {shortName}
                                        </p>
                                    </div>

                                    {/* Basic detail of customer  */}
                                    <div className='d-flex align-items-start gap-3 flex-wrap'>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
                                                {userDetailData.customer_summary.customer_name}
                                            </p>
                                            <a href={`mailto:${userDetailData.customer_summary.customer_email}`} target='_blank' className={`${location.pathname.includes("support") ? "pe-none" : ""} mb-0 w-max-content d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline`}>
                                                {userDetailData.customer_summary.customer_email}
                                            </a>
                                            <a href={`tel:${userDetailData.customer_summary.customer_phone}`} className={`${location.pathname.includes("support") ? "pe-none" : ""} d-flex w-max-content e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline`}>
                                                {/* +91 9878654567 */}
                                                {userDetailData.customer_summary.customer_phone}
                                            </a>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                Customer ID: <span className='e-font-weight-600'>
                                                    {userDetailData.profile.customer_id ? userDetailData.profile.customer_id : "-"}
                                                </span>
                                            </p>

                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                Resident Type: <span className='e-font-weight-600'>
                                                    {userDetailData.profile.resident_type || "-"}
                                                </span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                Global rebalance opt-out: <span className='e-font-weight-600'>{userDetailData.customer_summary.global_rebalance_opt_out === true ? "Yes" : "No"}</span>
                                            </p>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px '>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                RM name: <span className='e-font-weight-600'>
                                                    {userDetailData.customer_summary.rm_name}
                                                </span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                RM code: <span className='e-font-weight-600'>
                                                    {userDetailData.customer_summary.rm_code}
                                                </span>
                                            </p>
                                            <div className='d-flex align-items-center gap-2'>
                                                <div className='d-flex align-items-center gap-1'>
                                                    <CustomTooltip size={14}
                                                        color="#E7E7E7"
                                                        id="tooltip-referred-by"
                                                        content="Shows the user who referred this user to the platform." />
                                                    <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-14px'>
                                                        Referred by:
                                                    </p>
                                                </div>
                                                {(userDetailData.customer_summary?.referred_by?.rayi_customer_id || userDetailData.customer_summary?.referred_by?.name) ?
                                                    <Chip type={2}
                                                        hideDot={true}
                                                        // label={[userDetailData.customer_summary.referred_by.customer_id, userDetailData.customer_summary.referred_by.name].filter(Boolean).join(' · ')}
                                                        label={`${userDetailData.customer_summary.referred_by.rayi_customer_id} · ${userDetailData.customer_summary.referred_by.name}`}
                                                    />
                                                    :
                                                    <span className='e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>-</span>
                                                }
                                            </div>

                                        </div>

                                        <div className='d-inline-flex gap-3 h-stretch'>
                                            <div className='vr e-bg-lavender-blue'></div>
                                            <div className='d-flex flex-column gap-12px'>
                                                <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px d-flex align-items-center gap-2 justify-content-between' >
                                                    Risk Appetite: <span className='e-font-weight-600'>
                                                        {userDetailData.profile.risk_appetite || "-"}
                                                    </span>
                                                </p>
                                                {userDetailData.profile?.kyc_step &&
                                                    <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                            KYC step:
                                                        </p>

                                                        <Chip type={2}
                                                            dotClass={userDetailData.profile?.kyc_step === "account created" || userDetailData.profile?.kyc_step === "invested" ? "e-bg-green-crayola" : "e-bg-marigold"}
                                                            label={userDetailData.profile?.kyc_step} />
                                                    </div>
                                                }

                                                {userDetailData.profile?.account_creation_status &&
                                                    <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                            Account Creation:
                                                        </p>
                                                        <Chip type={2}
                                                            dotClass={userDetailData.profile?.account_creation_status === "In progress" ? "e-bg-marigold" : "e-bg-green-crayola"}
                                                            label={userDetailData.profile?.account_creation_status} />
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className='d-inline-flex gap-3 h-stretch'>
                                            <div className='vr e-bg-lavender-blue h-100'></div>
                                            <div className='d-flex flex-column gap-2'>
                                                <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                    <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                        Whatsapp:
                                                    </p>
                                                    <Chip type={2}
                                                        dotClass={userDetailData.profile.whatsapp_opt_in === false ? "e-bg-marigold" : "e-bg-green-crayola"}
                                                        label={userDetailData.profile.whatsapp_opt_in === false ? "Opted-Out" : "Opted-In"} />
                                                </div>
                                                <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                    <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                        Email:
                                                    </p>
                                                    <Chip type={2}
                                                        dotClass={userDetailData.profile.email_marketing_consent === false ? "e-bg-marigold" : "e-bg-green-crayola"}
                                                        label={userDetailData.profile.email_marketing_consent === false ? "Opted-Out" : "Opted-In"} />
                                                </div>
                                                <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                    <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                        Push notification:
                                                    </p>
                                                    <Chip type={2}
                                                        dotClass={userDetailData.profile.push_notification_opt_in === true ? "e-bg-green-crayola" : "e-bg-marigold"}
                                                        label={userDetailData.profile.push_notification_opt_in === true ? "Opted-In" : "Opted-Out"} />
                                                </div>
                                                <div className='d-flex align-items-center gap-2 justify-content-between'>
                                                    <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                        Nominee:
                                                    </p>
                                                    <Chip type={2}
                                                        dotClass={userDetailData.profile.nominee_opted_in === true ? "e-bg-green-crayola" : "e-bg-marigold"}
                                                        label={userDetailData.profile.nominee_opted_in === true ? "Opted-In" : "Opted-Out"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Toggle menu  */}
                                {location.pathname.includes("customers") &&
                                    <>
                                        <Icon icon="menu"
                                            size="1.5rem"
                                            height="1.375rem"
                                            color="#FFFFFF"
                                            className="position-absolute right-12px top-8px cursor-pointer"
                                            onClick={_handleToggleMenu} />

                                        {toggleMenu &&
                                            <>
                                                <OverLay isOpen={toggleMenu} onClose={_handleToggleMenu} />
                                                <div className={`${style.e_menu_popup} e-bg-white border-radius-8 position-absolute right-24px top-32px padding-10px-tb padding-12px-lr d-flex gap-20px flex-column z-index-99`}>
                                                    <div className='d-flex gap-1 cursor-pointer align-items-center '
                                                        onClick={_handleBlockCustomer}>
                                                        <img src={require("../../Assets/Image/Others/deactivate.svg").default}
                                                            draggable={false}
                                                            alt='block' />

                                                        <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                            {isCustomerBlocked === true ? 'Unblock Customer' : 'Block Customer'}
                                                        </p>
                                                    </div>
                                                    <div className='d-flex gap-1 cursor-pointer align-items-center'
                                                        onClick={_handleDataDelete}>
                                                        <img src={require("../../Assets/Image/Others/delete.svg").default}
                                                            draggable={false}
                                                            alt='delete' />

                                                        <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                            Data Delete Request
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </>
                                }

                                {/* Statistic cards */}
                                <div className='row row-cols-4 row-gap-4 pt-4'>
                                    <div className='col'>
                                        <StatisticCard title="Amount invested"
                                            value={userDetailData.customer_summary.total_amount_invested}
                                        />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Total returns"
                                            // color={userDetailData.customer_summary.total_returns < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"}
                                            value={userDetailData.customer_summary.total_returns_text}
                                        />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="XIRR"
                                            value={userDetailData.customer_summary.xirr}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Custom tab */}
                            <div className='d-flex py-4 mt-2'>
                                <CustomTab data={TAB_TITLES}
                                    flexGap="gap-2"
                                    selectedTab={selectedTab}
                                    tooltip={false}
                                    handleClick={_handleTab} />
                            </div>

                            <div className={`${style.e_data_wrapper} e-bg-ghost-white border-radius-16 e-box-shadow-ops-wrapper position-relative`}>

                                {userDetailData.profile.is_deleted &&
                                    <Chip label={"Deleted"}
                                        className={"e-text-dark-gray e-bg-pale-pink position-absolute right-16px top-16px"} />
                                }
                                {selectedTab === 1 ?
                                    <Profile data={userDetailData} />
                                    :
                                    selectedTab === 2 ?
                                        <Order />
                                        :
                                        selectedTab === 3 ?
                                            // <Holdings />
                                            <Portfolio />
                                            :
                                            selectedTab === 4 ?
                                                <SystematicPlans />
                                                :
                                                selectedTab === 5 ?
                                                    <FamilyDetails />
                                                    :
                                                    selectedTab === 6 ?
                                                        <RebalanceLog />
                                                        :
                                                        selectedTab === 7 ?
                                                            <NonFinancialChanges />
                                                            :
                                                            selectedTab === 8 ?
                                                                <AccountCreation />
                                                                :
                                                                selectedTab === 10 ?
                                                                    <Referral />
                                                                    :
                                                                    null
                                }
                            </div>
                        </div>
                    </>
                }
            </section>

            {/* confirm block customer modal */}
            {blockConfirm === true &&
                <ConfirmModal title={blockStatus ? "Confirm successfully" : isCustomerBlocked === true ? "Unblock user confirmation" : "Block user confirmation"}
                    description={blockStatus ? isCustomerBlocked === true ? "The customer blocked successfully." : "The customer Unblocked successfully." : isCustomerBlocked === true ? "You are about Unblock this user. This action will grant them access. Are you sure want to proceed?" : "You are about block this user. This action will revoke their access. Are you sure want to proceed?"}
                    status={blockStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => {
                        _blockCustomer();
                    }
                    }
                    handleSuccess={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                            setToggleMenu(false);
                        }, 200);
                    }} />
            }

            {/* confirm delete data modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Confirm successfully" : "Confirm data delete request"}
                    description={status ? "The data deleted successfully." : " This action will initiate the data deletion process for this customer. Please ensure all documentation is reviewed and compliant with data policies before proceeding."}
                    status={status}
                    loader={userDeleteLoader}
                    textInput={true}
                    label="Freshdesk ticket number"
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={(data) => _userDelete(data)}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setToggleMenu(false);
                            _handleBack();
                        }, 200);
                    }} />
            }

            {checkStatus === true &&
                <CheckStatusModal type={1}
                    data={kycStatusData}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCheckStatus(false);
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default CustomerDetail;
